module.exports = __webpack_public_path__ + "img/1679989433261-Screenshot_2023-03-28-13-48-58-71_1c337646f29875672b5a61192b9010f9.jpg.e85c85cd.webp";